import {
  UserCheck,
  CalendarCheck,
  Zap,
  Globe2,
  Users,
  Star,
  TrendingUp,
  Briefcase,
  ShieldCheck,
  Eye,
  PhoneOff,
  Sliders,
  Target,
  Layers,
  Search,
  Filter,
  CheckCircle2,
} from "lucide-react";

export const FUNNEL_STAGES = [
  {
    step: "01",
    title: "Analyse & Refine",
    desc: "Market sizing, ideal customer profile (ICP) definition, and criteria calibration.",
    icon: Search,
    color: "#0284c7",
  },
  {
    step: "02",
    title: "Nurture into Leads",
    desc: "Multi-touch intent cadences through calibrated email, calls, and digital touches.",
    icon: Filter,
    color: "#06b6d4",
  },
  {
    step: "03",
    title: "Convert to Prospects",
    desc: "Direct engagement with vetted decision-makers expressing commercial pain points.",
    icon: CheckCircle2,
    color: "#eab308",
  },
  {
    step: "04",
    title: "Get Found by Suspects",
    desc: "Inbound demand capture and omni-channel awareness touchpoints.",
    icon: Target,
    color: "#f97316",
  },
  {
    step: "05",
    title: "Identify Ideal Customer",
    desc: "Firmographic and technographic classification delivering high-conversion buyers.",
    icon: UserCheck,
    color: "#ef4444",
  },
];

export const LEAD_GEN_SERVICES = [
  { label: "Qualification of potential customers", icon: UserCheck },
  { label: "Appointment settings", icon: CalendarCheck },
  { label: "Quick response to incoming leads", icon: Zap },
  { label: "Expand Your Market", icon: Globe2 },
  { label: "Grow Your Following", icon: Users },
  { label: "Gather More Customer Reviews", icon: Star },
  { label: "Boost Your Revenue", icon: TrendingUp },
  { label: "Generate Business Opportunities", icon: Briefcase },
  { label: "Improve Lead Quality", icon: ShieldCheck },
  { label: "Build Visibility and Awareness", icon: Eye },
  { label: "Eliminate or Reduce Cold Calling (and Emailing)", icon: PhoneOff },
  { label: "Automate Lead Management", icon: Sliders },
];

export const ADVANCED_TECHNIQUES = [
  {
    icon: Target,
    title: "B2B Lead Generation",
    desc: "Precise outbound targeting finding verified contacts matching your exact industry and territory criteria.",
  },
  {
    icon: Layers,
    title: "Demand Generation",
    desc: "Creating sustainable commercial interest and educating the market on your solutions before outbound calls occur.",
  },
  {
    icon: CalendarCheck,
    title: "Appointment Scheduling",
    desc: "Direct calendar alignment with confirmed C-suite stakeholders ready to evaluate your enterprise services.",
  },
];

export const LEAD_GEN_FAQS = [
  {
    id: "faq-1",
    question: "What is Lead Generation?",
    answer:
      "Lead generation is the initiation of consumer interest or inquiry into products or services of a business. In B2B markets, it involves identifying decision-makers, validating their business contact information, and engaging them through targeted cadences to generate qualified sales opportunities.",
  },
  {
    id: "faq-2",
    question: "What Does Lead Generation Mean?",
    answer:
      "It represents the strategic process of turning cold prospects into potential buyers who have demonstrated intent, verified their contact points, and fit your ideal customer profile (ICP).",
  },
  {
    id: "faq-3",
    question: "What is the Lead Generation Process?",
    answer:
      "The process follows a structured sequence: ICP definition, firmographic data research, multi-layer data verification (email/phone), multi-channel outreach (email, social, calls), lead qualification (MQL/SQL verification), and booking meetings directly into sales reps' calendars.",
  },
  {
    id: "faq-4",
    question: "What are the Benefits of Lead Generation?",
    answer:
      "It eliminates unproductive cold outreach, shortens sales cycles, improves conversion rates, provides predictable pipeline revenue, and allows your in-house account executives to focus entirely on closing deals rather than prospecting.",
  },
  {
    id: "faq-5",
    question: "Why is Lead Generation Important?",
    answer:
      "Without a consistent flow of qualified leads, revenue growth becomes unpredictable. High-quality lead generation ensures your sales pipeline remains filled with qualified opportunities with genuine purchase intent, protecting your marketing budget from wasted spend.",
  },
];